import React, { FC } from 'react';
import { MdSearch as SearchIcon } from '@react-icons/all-files/md/MdSearch';
import { InputBase } from '@material-ui/core';
import { createUseStyles } from '../../../../../../../theming';
import clsx from 'clsx';

const useStyles = createUseStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    background: 'white',
    border: '1px solid #00000036',
    borderRadius: 4,
  },
  icon: {
    margin: 8,
  },
});

interface Props {
  className?: any;
  onChange: (searchString: string) => void;
}

const SearchBar: FC<Props> = ({ className, onChange }) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)}>
      <SearchIcon size={20} color='#0000008a' className={classes.icon} />
      <InputBase placeholder='Recherche ...' onChange={(event) => onChange(event.target.value as string)} fullWidth />
    </div>
  );
};

export default SearchBar;
